/**
 * Vorm van social_profiles.connected_platforms: per platform een object
 * met handle, of een lege string / undefined als legacy-restwaarde.
 */
export type ConnectedPlatformsMap = Record<
  string,
  { handle?: string; reauth_required?: boolean } | '' | undefined
>;

const SOCIAL_PLATFORMS = ['instagram', 'facebook', 'linkedin'];

/** Kanaal is bruikbaar: gekoppeld met handle en zonder verlopen sessie. */
export function isPlatformLive(connected: ConnectedPlatformsMap, platform: string): boolean {
  const account = connected[platform];
  return !!(account && typeof account === 'object' && account.handle && !account.reauth_required);
}

/**
 * Kanalen met ingeplande posts terwijl de koppeling ontbreekt of verlopen
 * is — die posts mislukken anders stil bij verzenden. Concepten tellen
 * niet mee: die worden nooit automatisch geplaatst.
 */
export function unconnectedScheduledPlatforms(
  posts: Array<{ status: string; platform: string }>,
  connected: ConnectedPlatformsMap,
): string[] {
  const scheduled = new Set(
    posts.filter((p) => p.status === 'scheduled').map((p) => p.platform),
  );
  return [...scheduled].filter(
    (p) => SOCIAL_PLATFORMS.includes(p) && !isPlatformLive(connected, p),
  );
}
